module.exports = __webpack_public_path__ + "static/media/bluedeal-vlaamse-veerkracht-nextgenerationeu.98dbfd4d.png";